// Libs
import update from 'immutability-helper';
import { concat, filter, findIndex } from 'lodash';

const initialState = () => ({
    showEditForm: false,
    isVisible: false,
    defaultRoute: 'tickets',
    focusedNavButton: '/tickets',
    filters: [],
    filterGroups: [],
    workspaceSettingsPanel: false,
    notificationsList: [],
    filtersFunctions: {
        tickets: props => filter(props.list, resource => resource.id === props.id)
    }
});

let index;
let groupedIdx;
let newFilters;
let newList;
let newNotif;
const navbarReducer = (state = initialState(), action) => {
    switch (action.type) {
        case 'SET_FOCUSED_NAV_BUTTON':
            return update(state, { focusedNavButton: { $set: action.payload } });
        case 'SET_DEFAULT_ROUTE':
            return update(state, { defaultRoute: { $set: action.payload } });
        case 'SET_WORKSPACE_SETTINGS_PANEL':
            return update(state, { workspaceSettingsPanel: { $set: action.payload } });
        case 'ADD_FILTER':
            if (action.payload?.type === 'link') {
                return update(state, { filters: { $set: concat(action.payload, state.filters) } });
            }
            return update(state, { filters: { $set: concat(state.filters, action.payload) } });
        case 'REMOVE_FILTER':
            newFilters = state.filters.filter(currentFilter => currentFilter.id !== action.payload);
            return update(state, { filters: { $set: newFilters } });
        case 'RESET_FILTERS':
            return update(state, { filters: { $set: [] }, filterGroups: { $set: [] } });
        case 'GET_NOTIFICATIONS_FULFILLED':
            newList = [];
            const ticketCommentNotifs = [];

            action.payload.forEach(notification => {
                // Add sender_name, ticketKey and ticketId to each notification
                notification.sender_name = notification.sender?.full_name || notification.object?.messaging_user_name;
                notification.ticketKey = notification.object?.related_ticket?.key || notification.object?.key;
                notification.ticketId = notification.object?.related_ticket?.id || notification.object?.id;
                const ticketKey = notification.ticketKey;
                if (notification.action_type === 'CREATE') {
                    // Group TicketComment notifications (action_type CREATE) by ticket key
                    let ticketGroup = ticketCommentNotifs.find(group => group.ticketKey === ticketKey);

                    if (!ticketGroup) {
                        ticketGroup = { ticketKey, notifications: [] };
                        ticketCommentNotifs.push(ticketGroup);
                    }

                    ticketGroup.notifications.push(notification);
                } else {
                    // Single notification for actions: ADD_ASSIGNEES, ADD_FOLLOWERS, UPDATE
                    newList.push([notification]);
                }
            });

            // Merge grouped notifications into newList
            ticketCommentNotifs.forEach(group => {
                newList.push(group.notifications);
            });

            return update(state, { notificationsList: { $set: newList } });
        case 'UPDATE_NOTIFICATION_FULFILLED':
            newNotif = action.payload;
            // Find the updated notif in the grouped notifs
            state.notificationsList.forEach((groupedNotif, groupedNotifIdx) => {
                if (findIndex(groupedNotif, notif => notif.id === newNotif.id) !== -1) {
                    index = findIndex(groupedNotif, notif => notif.id === newNotif.id);
                    groupedIdx = groupedNotifIdx;
                }
            });
            if (index !== -1 && groupedIdx !== -1) {
                // Add sender_name, ticketKey and ticketId to the notification
                newNotif.sender_name = newNotif.sender?.full_name || newNotif.object?.messaging_user_name;
                newNotif.ticketKey = newNotif.object?.related_ticket?.key || newNotif.object?.key;
                newNotif.ticketId = newNotif.object?.related_ticket?.id || newNotif.object?.id;
                return update(state, { notificationsList: { [groupedIdx]: { [index]: { $set: newNotif } } } });
            }
            return state;
        case 'DELETE_NOTIFICATION_FULFILLED':
            return update(state, {
                notificationsList: {
                    $set: state.notificationsList.filter(groupedNotif => !groupedNotif.some(notif => notif.id === action.payload))
                }
            });
        case 'LOGOUT_FULFILLED':
            return initialState();
        default:
            return state;
    }
};

export default navbarReducer;
